import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';

import { SentryErrorBoundary } from '../components/SentryErrorBoundary';
import { ActionDialogProvider } from '../components/ui';
import { AuthProvider } from '../features/auth/AuthProvider';
import { LocaleProvider } from '../features/locale/LocaleProvider';
import { ThemeProvider } from '../features/theme/ThemeProvider';

const queryClient = new QueryClient();

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <SentryErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <LocaleProvider>
            <ActionDialogProvider>
              <AuthProvider>{children}</AuthProvider>
            </ActionDialogProvider>
          </LocaleProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </SentryErrorBoundary>
  );
}
